exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 20%;\n  margin-right: 8px;\n  background:#333;\n}\n\ndiv {\n  height: 100%;\n  width: 100%;\n  background-size: cover;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/image/image.component.css
// module id = 213
// module chunks = 1